import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Box, Card, CardContent, Chip, IconButton, Typography } from '@mui/material';
import { DEFAULT_CATEGORY_ID, type BlueprintSection } from '../../../types';
import { ColumnTypeChip } from '../selected-columns/ColumnTypeChip';

interface AvailableColumnCardProps {
  column: BlueprintSection['columns'][0];
  categoryLabel: string;
  columnLabel: string;
  onAddColumn: (columnId: string) => void;
}

export function AvailableColumnCard({
  column,
  categoryLabel,
  columnLabel,
  onAddColumn,
}: AvailableColumnCardProps) {
  return (
    <Card
      sx={{
        marginBottom: 1,
        '&:hover': {
          backgroundColor: 'action.hover',
        },
      }}
    >
      <CardContent>
        <Box display="flex" alignItems="center" gap={1}>
          <IconButton size="small" onClick={() => onAddColumn(column.id)} sx={{ marginLeft: -1 }}>
            <ArrowBackIcon />
          </IconButton>
          <Box flex={1} display="flex" alignItems="center" gap={1}>
            <Typography variant="body2" fontWeight="medium">
              {columnLabel}
            </Typography>
            <ColumnTypeChip type={column.config.type} />
          </Box>
          {(column.category || DEFAULT_CATEGORY_ID) !== DEFAULT_CATEGORY_ID && (
            <Chip label={categoryLabel} size="small" variant="outlined" />
          )}
        </Box>
      </CardContent>
    </Card>
  );
}
